import axios from "axios";

const urlApi = process.env.VUE_APP_URL_API;
const apikey = process.env.VUE_APP_API_KEY;

export function getResoluciones() {
  return axios
    .get(urlApi, {
      headers: {
        "x-api-key": apikey,
      },
    })
    .then((res) => res.data);
}
